import {
  craeteSection,
  dublicateSection,
  getSections,
  getSectionsByApartment,
  getSectionsByApartmentForSelect,
  updateSection,
} from '@/api/sections'

export default {
  FETCH_SECTIONS({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      getSections(data).then(response => {
        commit('SET_SECTIONS', response.data)
        resolve(response.data)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  FETCH_APARTMENT_SECTIONS({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      getSectionsByApartment(data).then(response => {
        commit('SET_SECTIONS', response.data)
        resolve(response.data)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },

  FETCH_APARTMENT_SECTIONS_FOR_SELECT({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      getSectionsByApartmentForSelect(data).then(response => {
        commit('SET_SECTIONS_FOR_SELECT', response.data)
        resolve(response.data)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },

  ADD_SECTION(a, data) {
    return new Promise((resolve, reject) => {
      craeteSection(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  EDIT_SECTION(a, data) {
    return new Promise((resolve, reject) => {
      updateSection(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },

  DUBLICATE_SECTION(a, data) {
    return new Promise((resolve, reject) => {
      dublicateSection(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
}